import { useMemo } from "react";

export interface UtmParams {
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmContent: string;
  utmTerm: string;
  utmAdset: string;
  campaignId: string;
}

export function useUtm(): UtmParams {
  const utm = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      utmSource: params.get("utm_source") ?? "",
      utmMedium: params.get("utm_medium") ?? "",
      utmCampaign: params.get("utm_campaign") ?? "",
      utmContent: params.get("utm_content") ?? "",
      utmTerm: params.get("utm_term") ?? "",
      utmAdset: params.get("utm_adset") ?? "",
      campaignId: params.get("campaign_id") ?? "",
    };
  }, []); // Empty deps = computed once on mount

  return utm;
}
